import { render, staticRenderFns } from "./JsonTreeView.vue?vue&type=template&id=52ddc375&scoped=true"
import script from "./JsonTreeView.vue?vue&type=script&lang=js"
export * from "./JsonTreeView.vue?vue&type=script&lang=js"
import style0 from "./JsonTreeView.vue?vue&type=style&index=0&id=52ddc375&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ddc375",
  null
  
)

export default component.exports